import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { AxiosResponse } from 'axios'
import { requests } from '.'

// Configure request setup
const serviceName = 'AiWrapperService'
const host = servicesConfig.AiWrapper
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response
const responseBody = (res: AxiosResponse) => res.data

interface YearEndRecapData {
  companyId?: string
  topUserPercentile?: number
  userTitle?: string
  userRankingTier?: string
  totalAppointmentsBookedByAI?: number
  voiceAIMinutes?: number
  totalMessagesSent?: number
  reviewsHandledCount?: number
  contentAIImagesCount?: number
  agentsCreated?: number
  aiProductsUsedCount?: number
  tokensUsed?: number
  [key: string]: any
}

interface YearEndRecapResponse {
  success: boolean
  showRecap: boolean
  data?: YearEndRecapData
  message?: string
}

const YearEndRecapService = {
  /**
   * Check if year-end recap should be shown for a company
   * Uses showRecap flag from backend (handles all eligibility checks)
   */
  checkRecapAvailability: async (companyId: string): Promise<{ 
    isAvailable: boolean
    data?: YearEndRecapData 
  }> => {
    try {
      const url = `/year-end-recap?companyId=${companyId}`
      const res: YearEndRecapResponse = await request().get(url).then(responseBody).catch(() => null)
      
      // Backend returns showRecap flag indicating eligibility
      if (res?.success && res?.showRecap && res?.data) {
        return {
          isAvailable: true,
          data: res.data
        }
      }
      
      return { isAvailable: false }
    } catch (error) {
      console.error('Year-end recap availability check failed:', error)
      return { isAvailable: false }
    }
  }
}

export default YearEndRecapService
